import { Helmet } from 'react-helmet-async';
import config from '~/config';

type MetaTitleProps = {
  children: React.ReactNode;
};

const MetaTitle = ({ children }: MetaTitleProps) => {
  const title = Array.isArray(children) ? children.join('') : children;

  return <Helmet title={title + ' | ' + config.APP_TITLE} />
}

export default MetaTitle;